
import $api from "@/api/main";
import { defineComponent } from "vue";
import { ElMessage } from "element-plus";
export default defineComponent({
	props: {
		removeApiName: String,
		removeId: [String, Number],
		flowStatus: [String, Number],
	},
	emits:['removeSuccess'],
	setup(props: any, { emit }: any) {
		const confirm = () => {
			$api[props.removeApiName](props.removeId).then((res: any) => {
				if (res) {
					ElMessage.success("移除成功");
					emit("removeSuccess", true);
				}
			});
		};
		return {
			confirm,
		};
	},
});
